import React, { useEffect } from "react";
import { Link } from "react-router-dom";
// import { companyDetails, logoImg, routes } from "../constant";
import { BsFacebook, BsLinkedin, BsTwitter, BsYoutube } from "react-icons/bs";
import { companyDetails, logoImg, routes } from "../../constant";

const Thankyou = () => {
  useEffect(() => {
    // Only run in browser environment - early return prevents any window access during build
    if (typeof window === 'undefined') {
      return;
    }

    // Store window reference to avoid repeated checks
    const win = window;
    if (!win) return;

    // Function to push GTM events with proper SPA virtual pageview
    // This function ensures events fire even with server caching
    const pushGTMEvents = () => {
      try {
        // Ensure dataLayer exists - critical for cached pages
        if (!win.dataLayer) {
          win.dataLayer = [];
        }
        
        const pagePath = '/thank-you';
        const pageTitle = 'Thank You - Velandirch AI';
        const pageLocation = win.location.href;
        const timestamp = new Date().getTime();
        
        // Push events immediately and synchronously to avoid cache issues
        // Use multiple event types to ensure at least one fires
        
        // 1. Push virtual pageview for SPA - Use gtm.historyChange for React Router navigation
        win.dataLayer.push({
          event: 'gtm.historyChange',
          page_path: pagePath,
          page_title: pageTitle,
          page_location: pageLocation,
          timestamp: timestamp
        });

        // 2. Also push standard page_view event (some GTM setups listen for this)
        win.dataLayer.push({
          event: 'page_view',
          page_path: pagePath,
          page_title: pageTitle,
          page_location: pageLocation,
          timestamp: timestamp
        });

        // 3. Push conversion event for form submission
        win.dataLayer.push({
          event: 'form_submission',
          event_category: 'Contact Form',
          event_label: 'Thank You Page',
          page_path: pagePath,
          page_location: pageLocation,
          timestamp: timestamp
        });

        // 4. Also push to gtag if available (for Google Ads conversion tracking)
        // Use immediate execution to avoid cache issues
        if (typeof win.gtag === 'function') {
          try {
            // Send page_view to gtag immediately
            win.gtag('config', 'AW-11500271901', {
              'page_path': pagePath,
              'page_title': pageTitle,
              'send_page_view': true
            });
            
            // Send conversion event immediately
            win.gtag('event', 'conversion', {
              'send_to': 'AW-11500271901',
              'event_category': 'Contact Form',
              'event_label': 'Form Submission'
            });
          } catch (gtagError) {
            // Fallback if gtag fails
            if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
              console.warn('gtag error:', gtagError);
            }
          }
        }

        // 5. Force GTM to process by pushing trigger events
        // Multiple triggers ensure events are processed even with caching
        if (win.dataLayer) {
          // Push DOM ready event
          win.dataLayer.push({ event: 'gtm.dom' });
          
          // Push load event
          win.dataLayer.push({ event: 'gtm.load' });
        }

        // 6. Use sendBeacon as fallback for critical events (works even if page is cached/unloading)
        if (navigator && navigator.sendBeacon) {
          try {
            // Note: GTM doesn't directly support sendBeacon, but this ensures data is sent
            // The dataLayer push above is the primary method
            // Future implementation: navigator.sendBeacon(url, JSON.stringify({...}))
          } catch (beaconError) {
            // Ignore beacon errors
          }
        }
      } catch (error) {
        // Silently fail if GTM is not available
        // Only log in development to avoid build issues
        if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
          console.warn('GTM event push failed:', error);
        }
      }
    };

    let checkGTMInterval = null;

    try {
      // Wait a bit for React Router navigation to complete
      const initGTM = () => {
        const dataLayer = win.dataLayer;
        const gtm = win.google_tag_manager;
        
        if (dataLayer) {
          // Push events immediately if dataLayer exists
          pushGTMEvents();
          
          // If GTM is not loaded yet, wait for it
          if (!gtm) {
            let attempts = 0;
            const maxAttempts = 30; // Increased to 3 seconds
            checkGTMInterval = setInterval(() => {
              attempts++;
              if (win.google_tag_manager || attempts >= maxAttempts) {
                if (checkGTMInterval) {
                  clearInterval(checkGTMInterval);
                  checkGTMInterval = null;
                }
                // Push events again once GTM is loaded
                if (attempts < maxAttempts) {
                  pushGTMEvents();
                }
              }
            }, 100);
          }
        } else {
          // Wait for dataLayer to be initialized
          let attempts = 0;
          const maxAttempts = 30;
          checkGTMInterval = setInterval(() => {
            attempts++;
            if (win.dataLayer || attempts >= maxAttempts) {
              if (checkGTMInterval) {
                clearInterval(checkGTMInterval);
                checkGTMInterval = null;
              }
              if (win.dataLayer && attempts < maxAttempts) {
                pushGTMEvents();
              }
            }
          }, 100);
        }
      };

      // Small delay to ensure React Router navigation is complete
      setTimeout(initGTM, 50);
    } catch (error) {
      // Silently fail if there's an error
      // Only log in development to avoid build issues
      if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
        console.warn('GTM initialization failed:', error);
      }
    }

    // Cleanup function to clear interval on unmount
    return () => {
      if (checkGTMInterval) {
        clearInterval(checkGTMInterval);
        checkGTMInterval = null;
      }
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col justify-between bg-primary/20">
      <div className="py-4 top-0 w-full bg-black/10 backdrop-blur-md z-50 text-black">
        <div className="wrapper flex justify-between items-center gap-10">
          <div className="flex justify-between items-center gap-20 w-full pl-[1rem] lg:pl-0">
            <Link to="/" className="cursor-pointer relative">
              <img src={logoImg} className="h-[4rem] md:h-[5rem] " alt="logo" />
              {/* <small className="text-sm font-light text-[#CAA562] absolute bottom-0 left-1/2 -translate-x-1/2">
                Parvesha
              </small> */}
            </Link>
          </div>
        </div>
      </div>
      <div className="wrapper h-full flex flex-col items-center py-[8rem] gap-3 text-[#2e2e45] text-center">
        <h1 className="heading-1">Thank You!</h1>
        <p className="desc !font-semibold">
          We have received your message and will get back to you as soon as
          possible.
        </p>
        <Link to="/" className="primary-btn w-fit mt-4 text-black">
          Home
        </Link>
      </div>
      <div className="py-14 bg-[#2e2e45]">
        <div className="wrapper text-white">
          <div className="flex md:flex-row flex-col justify-between gap-10">
            <div className="flex flex-col items-center">
              <img src={logoImg} className="h-[4rem] md:h-[5rem]" alt="" />
              <p className="desc md:max-w-[15rem] text-sm text-center mt-5">
                We have rapidly grown into a trusted partner for organizations
                seeking digital transformation, enhanced operational efficiency.
              </p>
            </div>
            <div className="flex md:flex-row flex-col gap-10">
              <div className="flex flex-col gap-2">
                <h6 className="font-medium mb-1">Quick Links</h6>
                {routes.map(({ name, path }) => (
                  <Link
                    key={path}
                    to={path}
                    className="text-white/70 desc text-sm hover:text-primary transition-all duration-300"
                  >
                    {name}
                  </Link>
                ))}
              </div>
              <div className="flex flex-col gap-2">
                <h6 className="font-medium mb-1">Contact Us</h6>
                <div className="flex flex-col">
                  <h6 className="text-[.9rem] mb-1">Phone</h6>
                  <Link
                    to={`tel:${companyDetails.phone}`}
                    className="text-white/70 desc text-sm"
                  >
                    {companyDetails.phone}
                  </Link>
                </div>
                <div className="flex flex-col mt-2">
                  <h6 className="text-[.9rem] mb-1">Office Address</h6>
                  <p className="text-white/70 desc text-sm max-w-[15rem]">
                    {companyDetails.address}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="pt-4 mt-7 border-t text-gray-500 border-primary w-full">
            <div className="flex justify-center gap-5 w-full">
              <div className="flex gap-5 items-center mt-5">
                <Link>
                  <BsFacebook className="text-xl text-gray-500 hover:text-primary transition-all duration-300" />
                </Link>
                <Link>
                  <BsTwitter className="text-xl text-gray-500 hover:text-primary transition-all duration-300" />
                </Link>
                <Link>
                  <BsLinkedin className="text-xl text-gray-500 hover:text-primary transition-all duration-300" />
                </Link>
                <Link>
                  <BsYoutube className="text-xl text-gray-500 hover:text-primary transition-all duration-300" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Thankyou;
